export default "__VITE_ASSET__BFvJib$m__"